// src/pages/SendNotifications/SendNotifications.jsx
import React from 'react';
import { Helmet } from 'react-helmet';
import SendNotification from '../../components/SendNotification/SendNotification';

const SendNotifications = () => {
    return (
        <>
            <Helmet>
                <title>Enviar Notificaciones - PetitPrime</title>
                <meta name="description" content="Envía notificaciones personalizadas a tus clientes" />
            </Helmet>

            <div className="container mx-auto px-4 py-8">
                <SendNotification />
            </div>
        </>
    );
};

export default SendNotifications; 